interface Ifoot {
  preparedBy: string | null | undefined;
  approvedBy: string | null | undefined;
}
const TFoot = ({ preparedBy, approvedBy }: Ifoot) => {
  return (
    <tfoot>
      <tr>
        <th colSpan={38} align="left">
          Verify By Line Inspector :{' '}
        </th>
      </tr>
      <tr>
        <th colSpan={13} style={{ fontSize: '30px' }}>
          ✓ OK
        </th>
        <th colSpan={13} style={{ fontSize: '30px' }}>
          ⨯ NOT OK
        </th>
        <th colSpan={12} style={{ fontSize: '30px' }}>
          &#10134;&#10134; NO PRODN.RUN
        </th>
      </tr>
      <tr>
        <th colSpan={19} align="left">
          VERIFIED BY(SECTION INCHARGE.): {preparedBy}
        </th>
        <th colSpan={19} align="left">
          APPROVED BY (Quality Head): {approvedBy}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
